import { render, staticRenderFns } from "./Portrait.vue?vue&type=template&id=3ea963de&scoped=true&"
import script from "./Portrait.vue?vue&type=script&lang=js&"
export * from "./Portrait.vue?vue&type=script&lang=js&"
import style0 from "./Portrait.vue?vue&type=style&index=0&id=3ea963de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea963de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
